import picture1 from 'assets/images/skincare/scienceModule/science-module-1.jpg';
import picture2 from 'assets/images/skincare/scienceModule/science-module-2.jpg';
import picture3 from 'assets/images/skincare/scienceModule/science-module-3.jpg';

const scienceModule = productName => ({
  title: productName
    ? `A ${productName} developed by experts and loved by dermatologists`
    : 'Developed by experts, loved by dermatologists',
  description:
    'Made by our in-house cosmetic chemists and tested by renowned dermatologists — for scientifically backed formulas that address every thing affecting your skin.',
  experts: [
    {
      image: picture1,
      alt: 'Close-up of Marie Mignon, VP of Research & Development',
      name: 'Marie Mignon',
      description: (
        <>
          Chief Scientific <br /> Officer
        </>
      ),
    },
    {
      image: picture2,
      alt: 'Close-up of Dr. LJ Maxfield, DO, FAAD board-certified dermatologist',
      name: 'Dr. LJ Maxfield',
      description: (
        <>
          DO, FAAD board-certified <br /> dermatologist
        </>
      ),
    },
    {
      image: picture3,
      alt: 'Close-up of Celine Leconte, Director of Research & Development, Skincare',
      name: 'Celine Leconte',
      description: (
        <>
          Director of Research &<br /> Development, Skincare
        </>
      ),
    },
  ],
});

export default scienceModule;
